// @ts-check
import { LBButton } from '@linearb/buzz';
import { TRACKING } from 'common/constants/constants';
import { LINE_HEIGHT } from 'common/constants/sizes';
import { premiumRequest } from 'common/services/general.service';
import * as TrackingService from 'common/services/tracking.service';
import { navigateBookDemoClick } from 'common/utils/utils';
import TermsAndPolicy from 'components/TermsAndPolicy';
import { HyperLink } from 'components/base/HyperLink';
import Text from 'components/base/Text';
import { Flex, Padding } from 'components/base/layout-components';
import endOfTrailDudes from 'images/characters/end-of-trail-dudes.svg';
import svgLogo from 'images/logos/linearb-logo.svg';
import { PureComponent } from 'react';
import styled from 'styled-components';

const Logo = styled.img`
  height: 5rem;
  width: 10rem;
`;

const StyledImg = styled.img`
  width: 27rem;
`;

export default class OverdueModal extends PureComponent {
  subscribe = async () => {
    navigateBookDemoClick();
    await premiumRequest();
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.OVERDUE,
      click_type: TRACKING.CLICK.PREMIUM
    });
  };

  render() {
    return (
      <Padding padding='medium'>
        <Logo src={svgLogo} />

        <Flex justify='center' pt='small' pb='large'>
          <StyledImg src={endOfTrailDudes} />
        </Flex>
        <Text size='x-x-x-large' pb='1rem' weight='300'>
          End of trial period
        </Text>
        <Text lineHeight={LINE_HEIGHT['x-large']} size='large'>
          We're sure you have enjoyed your LinearB experience but your trial
          period has now ended.
          <br />
          To continue enjoying LinearB in its full glory please upgrade to one
          of our{' '}
          <HyperLink
            size=';arge'
            target='_blank'
            rel='noopener noreferrer'
            href='https://linearb.io/pricing'
          >
            paid plans
          </HyperLink>
          .
          <br />
          Don't worry, your trial data is not lost, and you can access it once
          you upgrade.
        </Text>

        <Flex items='end' pt='large'>
          <Flex grow='1'>
            <TermsAndPolicy page={TRACKING.PAGES.OVERDUE} />
          </Flex>
          <LBButton size='lg' onClick={() => this.subscribe()}>
            Upgrade Now
          </LBButton>
        </Flex>
      </Padding>
    );
  }
}
